/* eslint-disable no-console */

import { register } from 'register-service-worker'
import router from './router';
import store from './store'
export let subscription = null
const publicVapidKey = "BNlgHAmqoDF1_3n2wM7x7fLPtBi8DBGzbdBJcSQ_8y9KQbwNreI6_ev4iPUt8D_wl_YNqJeVw1wWiPOFDBFF-gE"

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(reg) {
            if (Notification.permission !== 'granted')  
                    Notification.requestPermission().then(permission => {});
            subscription = reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
            }).then(sub=> { 
                store.dispatch('PUSH_SUBSCRIPTION', sub);
            }).catch(err=>{  
                console.error('Unable to subscribe to push', err);
                return null
            });
        },
        registered() {
            
        },
        cached() {
        },
        updatefound() {
        },
        updated() {
        },
        offline() {
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })

}